// @ts-nocheck
// this file was patched by @terra

import { z } from 'zod';

/////////////////////////////////////////
// APPLICATION LOGIN BEHAVIOR SCHEMA
/////////////////////////////////////////

export const ApplicationLoginBehaviorSchema = z.object({
})

export type ApplicationLoginBehavior = z.infer<typeof ApplicationLoginBehaviorSchema>

export default ApplicationLoginBehaviorSchema;
